{
    "title": "JSON schema for KLPMS settings",
    "$schema": "https://degeetia.ee/schema/klpms/settings",
    "type": "object",
    "properties": {
        "lang": {
            "type": "string"
        },
        "toleranceCompensation": {
            "type": "boolean"
        },
        "nominalGraph": {
            "type": "boolean"
        },
        "filter": {
            "type": "boolean",
            "title": "Use filter 1"
        },
        "filterRepeatCount": {
            "type": "integer",
            "title": "Filter 1 window width",
            "minimum": 5,
            "maximum": 20
        },
        "filterCoef": {
            "type": "number",
            "title": "Filter 1 maximum error (scaled 100x)",
            "minimum": 20,
            "maximum": 200
        },
        "filterMaxError": {
            "type": "integer",
            "title": "Filter 1 ignored edge",
            "minimum": 1,
            "maximum": 20
        },
        "filter2": {
            "type": "boolean",
            "title": "Use filter 2"
        },
        "filter2RepeatCount": {
            "type": "integer",
            "title": "Filter 2 window width",
            "minimum": 5,
            "maximum": 20
        },
        "filter2Coef": {
            "type": "number",
            "title": "Filter 2 maximum error (scaled 100x)",
            "minimum": 20,
            "maximum": 200
        },
        "filter2MaxError": {
            "type": "integer",
            "title": "Filter 2 ignored edge",
            "minimum": 1,
            "maximum": 20
        },
        "ncpRotated": {
            "type": "boolean"
        },
        "mode": {
            "type": "integer",
            "enum": [0, 1],
            "enumNames": ["automatic", "manual"]
        },
        "edgeSearch": {
            "type": "boolean"
        },
        "debugModeMeasuring": {
            "type": "boolean"
        },
        "showOnlyCenterPoints": {
            "type": "boolean"
        },
        "isGlobalCompensation": {
            "type": "boolean",
            "title": "Is global compensation activated"
        },
        "globalCompensation": {
            "type": "array",
            "title": "Global compensation for each line",
            "maxItems": 5,
            "items": {
                "type": "number",
                "title": "Global compensation (mm, scaled 10x)",
                "minimum": -10,
                "maximum": 10
            }
        }
    }
}
